import { render, staticRenderFns } from "./batch-import-modal.vue?vue&type=template&id=194bef86&"
import script from "./batch-import-modal.vue?vue&type=script&lang=js&"
export * from "./batch-import-modal.vue?vue&type=script&lang=js&"
import style0 from "./batch-import-modal.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports